/* lua.js generated code 0.3.0 */

require("clover/net/Http")
var AppController = AppController || table()
if (__IOS) {
    AppController = oc.HeAppController
}
// StartLevelHttp ---------------------------------------------------------
// StartLevelHttp = xClass("StartLevelHttp", HttpBase)
// StartLevelHttp.prototype.load = function (levelId, itemList, energyBuff, gameLevelType) {
//     var self = this
//     if (gameLevelType === GameLevelType.kEditor) {
//         self.onLoadingComplete()
//     } else {
//         let gameMode
//         var body = table(
//             [1, "levelId", levelId],
//             [1, "gameMode", gameMode],
//             [1, "energyBuff", energyBuff],
//             [1, "activityFlag", gameLevelType],
//             [1, "requestTime", Localhost.time()]
//         )
//         UserManager.getInstance().cacheHttp(kHttpEndPoints.startLevel, body)
//         if (NetworkConfig.writeLocalDataStorage) {
//             Localhost.getInstance().flushCurrentUserData()
//         } else {
//             cc.log("Did not write user data to the device.")
//         }
//         self.onLoadingComplete()
//     }
// }
// // ActiveHeadFrameHttp ---------------------------------------------------------
// ActiveHeadFrameHttp = xClass("ActiveHeadFrameHttp", HttpBase)
// ActiveHeadFrameHttp.prototype.load = function (targetId) {
//     var self = this
//     if (gameLevelType === GameLevelType.kEditor) {
//         self.onLoadingComplete()
//     } else {
//         var body = table([1, "targetId", targetId], [1, "requestTime", Localhost.time()])
//         UserManager.getInstance().cacheHttp(kHttpEndPoints.activeHeadFrame, body)
//         if (NetworkConfig.writeLocalDataStorage) {
//             Localhost.getInstance().flushCurrentUserData()
//         } else {
//             cc.log("Did not write user data to the device.")
//         }
//         self.onLoadingComplete()
//     }
// }
// PassLevelHttp ---------------------------------------------------------
// PassLevelHttp = xClass("PassLevelHttp", HttpBase)
// PassLevelHttp.calcSig = function (cacheHttp) {
//     var params = table()
//     params.levelId = cacheHttp.levelId
//     params.score = cacheHttp.score
//     params.star = cacheHttp.star
//     params.targetCount = cacheHttp.targetCount || ""
//     params.requestTime = cacheHttp.requestTime
//     params.opLog = cacheHttp.opLog || ""
//     params.bundle = cacheHttp.bundle
//     params.curMd5 = cacheHttp.curMd5
//     params.lvmd5 = cacheHttp.lvmd5
//     params.idfa = cacheHttp.idfa || ""
//     var paramKeys = table()
//     for (var k in params) {
//         var v = params[k]
//         table.insert(paramKeys, k)
//     }
//     table.sort(paramKeys)
//     var md5Src = ""
//     for (var _ in paramKeys) {
//         var v = paramKeys[_]
//         md5Src = md5Src + tostring(params[v])
//     }
//     cc.log(md5Src)
//     // FIXME: hecore
//     // return he.HeMathUtils.ca(md5Src)
//     return md5Src
// }
// dispatched event.data = response.rewardItems é€šè¿‡å…³å¡èŽ·å¾—å¥–åŠ±
//  <request>
//	  <property code="levelId" type="int" desc="å…³å¡id" />
//	  <property code="score" type="int" desc="å…³å¡å¾—åˆ†" />
//    <property code="star" type="int" desc="å…³å¡æ˜Ÿçº§" />	
//    <property code="stageTime" type="int" desc="å…³å¡æ‰€ç”¨æ—¶é—´" />
//    <property code="coin" type="int" desc="å…³å¡å†…æŽ‰è½é“¶å¸æ•°é‡" />	
//	  <property code="targetCount" type="int" desc="å…³å¡å†…æ”¶é›†çš„ç›®æ ‡æ•°é‡"/>	
//	  <property code="opLog" type="string" desc="å½“æ¬¡è¿‡å…³çš„opertaion log"/>
//	  <property code="requestTime" type="long" desc="请求时间" />
//  </request>
//  <response>
//		<list code="rewardItems" ref="Reward" desc="é€šè¿‡å…³å¡èŽ·å¾—å¥–åŠ±"/>
//	</response>
// PassLevelHttp.prototype.load = function (levelId, score, star, stageTime, coin, targetCount, opLog, gameLevelType) {
//     var self = this
//     if (gameLevelType === GameLevelType.kEditor) {
//         self.onLoadingComplete()
//     } else {
//         // FIXME: level info md5
//         // var lvmd5 = he.ResManager.getInstance().getFileMd5("meta/level/" + levelId + ".inf")
//         // var curMd5 = he.ResManager.getInstance().getCurVersion()
//         var lvmd5 = ''
//         var curMd5 = ''
//         var cacheHttp = table(
//             [1, "levelId", levelId],
//             [1, "score", score],
//             [1, "star", star],
//             [1, "stageTime", stageTime],
//             [1, "coin", coin],
//             [1, "targetCount", targetCount],
//             [1, "requestTime", Localhost.time()],
//             // [1, "activityFlag", actFlag],
//             [1, "levelMd5", lvmd5],
//             [1, "curMd5", curMd5],
//             [1, "bundle", _G.bundleVersion],
//             [1, "clientTopLevel", MetaManager.getInstance().getMaxNormalLevelByLevelArea()]
//         )
//         if (__IOS) {
//             cacheHttp.idfa = AppController.getAdvertisingIdentifier() || ""
//         } else if (__ANDROID) {
//             cacheHttp.idfa = he.MetaInfo.getInstance().getUdid()
//         }
//         if (__ANDROID) {
//             cacheHttp.opLog = opLog
//         }
//         cacheHttp.cacheCode = PassLevelHttp.calcSig(cacheHttp)
//         UserManager.getInstance().cacheHttp(kHttpEndPoints.passLevel, cacheHttp)
//         if (NetworkConfig.writeLocalDataStorage) {
//             Localhost.getInstance().flushCurrentUserData()
//         } else {
//             cc.log("Did not write user data to the device.")
//         }
//         self.onLoadingComplete()
//     }
// }

// IngameHttp ---------------------------------------------------------
IngameHttp = xClass("IngameHttp", HttpBase)
IngameHttp.prototype.load = function (id, orderId, channel, detail, tradeId) {
    var self = this
    cc.log("IngameHttp:load", id, orderId, channel, detail, tradeId)
    assert(id != null, "id must not a nil")
    assert(orderId != null, "orderId must not a nil")
    assert(channel != null, "channel must not a nil")
    var body = table(
        [1, "id", id],
        [1, "orderId", orderId],
        [1, "channel", channel],
        [1, "detail", detail],
        [1, "tradeId", tradeId],
        [1, "requestTime", Localhost.time()],
        [1, "imsi", he.MetaInfo.getInstance().getImsi()],
        [1, "udid", he.MetaInfo.getInstance().getUdid()]
    )
    UserManager.getInstance().cacheHttp(kHttpEndPoints.ingame, body)
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
    self.onLoadingComplete()
}
SettingHttp = xClass("SettingHttp", HttpBase)
SettingHttp.prototype.load = function (settingFlag) {
    var self = this
    actId = actId || 0
    var context = self
    var body = table([1, "setting", settingFlag])
    if (NetworkConfig.useLocalServer) {
        UserManager.getInstance().cacheHttp(kHttpEndPoints.setting, body)
        if (NetworkConfig.writeLocalDataStorage) {
            Localhost.getInstance().flushCurrentUserData()
        } else {
            cc.log("Did not write user data to the device.")
        }
        context.onLoadingComplete()
        return 
    }
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("SettingHttp fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("SettingHttp success")
            context.onLoadingComplete()
        }
    }
    self.transponder.call(kHttpEndPoints.setting, body, loadCallback, rpc.SendingPriority.kHigh, false)
}
GuidePropHttp = xClass("GuidePropHttp", HttpBase)
GuidePropHttp.prototype.load = function (index, itemType, levelId) {
    var self = this
    UserManager.getInstance().cacheHttp(kHttpEndPoints.guideProp, table(
        [1, "idx", index],
        [1, "type", itemType],
        [1, "levelId", levelId],
        [1, "requestTime", Localhost.time()]
    ))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
    self.onLoadingComplete()
}
// GetStarRewardHttp ---------------------------------------------------------
GetStarRewardHttp = xClass("GetStarRewardHttp", HttpBase)
GetStarRewardHttp.prototype.load = function (data) {
    var self = this
    var context = self
    var id = data.starRewardId
    data.requestTime = Localhost.time()
    var loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("mark fail, err: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("mark success")
            var data = MetaManager.getInstance().getStarRewardById(id)
            data.rewardItems = data.rewards
            if (type(data) === "table" && type(data.rewardItems) === "table") {
                for (var k1 in data.rewardItems) {
                    var v1 = data.rewardItems[k1]
                    var itemId = v1.itemId
                    var itemNumber = v1.num
                    UserProp.getInstance().rewardProp(itemId, itemNumber, null, null, ModuleName.STAR_TOTAL)
                }
            }
            context.onLoadingComplete(data)
        }
    }
    UserManager.getInstance().cacheHttp(kHttpEndPoints.getStarRewards, data)
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    }
    loadCallback()
}

StartAreaBeginTimeHttp = xClass("StartAreaBeginTimeHttp", HttpBase)
StartAreaBeginTimeHttp.prototype.load = function (levelAreaId) {
    var self = this
    UserManager.getInstance().cacheHttp(kHttpEndPoints.startAreaBeginTime, table([1, "levelAreaId", levelAreaId], [1, "requestTime", Localhost.time()]))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
    self.onLoadingComplete()
}
GetPropsInGameHttp = xClass("GetPropsInGameHttp", HttpBase)
GetPropsInGameHttp.prototype.load = function (actId, levelId, itemIds) {
    let self = this
    // body
    let boady = table(
        [1, "actId", actId],
        [1, "levelId", levelId],
        [1, "itemIds", itemIds]
    )
    UserManager.getInstance().cacheHttp(kHttpEndPoints.getPropsInGame, boady)
    UserManager.getInstance().flushUserData()
    self.onLoadingComplete()
}
UsePropsOfflineHttp = xClass("UsePropsOfflineHttp", HttpBase)
UsePropsOfflineHttp.prototype.load = function (itemType, levelId, param, itemList) {
    var self = this
    self.onLoadingComplete()
}